import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const CompanyStatusCards = () => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const location = useLocation();
    const [userName, setUserName] = useState('');
    const [userEmail, setUserEmail] = useState(null);
    const [companyName, setCompanyName] = useState('');

    useEffect(() => {
        // Get the userName and userId from location.state if available, otherwise from localStorage
        const storedUser = JSON.parse(localStorage.getItem('user'));  // Assuming 'user' is stored in localStorage
        // Assuming 'companyName' is stored in localStorage
        const userNameFromLocation = location.state?.userName || storedUser?.userName || '';
        const userEmailFromLocation = location.state?.userEmail || storedUser?.userEmail || null;

        setUserName(userNameFromLocation);
        setUserEmail(userEmailFromLocation);
        setCompanyName(storedUser.companyName); // Set companyName from localStorage

    }, [location]);  // Re-run the effect when the location changes

    const [countOfJobs, setCountOfJobs] = useState(0);
    const [evergreenJobs, setEvergreenJobs] = useState(0);
    const [countOfApplications, setCountOfApplications] = useState(0);
    const [countOfDreamApplications, setCountOfDreamApplications] = useState(0)
    // const [countOfShortlistedCandiCompany, setCountOfShortlistedCandiCompany] = useState(0);
    const DATA = [
        { title: countOfJobs, subtitle: "Total Jobs", link: "/hr-dashboard/all-jobs", state: { activeTab: "regularJobs" } },
        { title: evergreenJobs, subtitle: "Evergreen Jobs", link: "/hr-dashboard/my-jobs", state: { activeTab: "evergreenJobs" } },
        { title: countOfApplications, subtitle: "Applicants", link: "/hr-dashboard/hr-applications" },
        // { icon: faStar, title: countOfShortlistedCandiCompany, subtitle: "Shortlisted" },
        {
           
            title: countOfDreamApplications,
            subtitle: 'Dream Applications',
           link: "/hr-dashboard/hr-applications", state: { activeTab: "dreamApplication" } },
    ];


    const fetchCounts = useCallback(async (userEmail, companyName) => {
        try {
            const jobsResponse = await axios.get(`${BASE_API_URL}/CountOfJobsPostedByEachCompany`, {
                params: { userEmail: userEmail }
            });
            const applicationsResponse = await axios.get(`${BASE_API_URL}/CountOfApplicationByEachCompany`, {
                params: { userEmail: userEmail }
            });

            const evergreenJobsResponse = await axios.get(`${BASE_API_URL}/countOfTotalEvergreenJobsByCompany`, {
                params: { companyName: companyName }
            })

            const dreamApplicationResponse = await axios.get(`${BASE_API_URL}/countOfDreamApplications`, {
                params: { userEmail: userEmail }
            })
            setCountOfJobs(jobsResponse.data);
            setCountOfApplications(applicationsResponse.data);
            setEvergreenJobs(evergreenJobsResponse.data);
            setCountOfDreamApplications(dreamApplicationResponse.data)
            // setCountOfShortlistedCandiCompany(shortlistedResponse.data);
        } catch (error) {
        }
    }, [userEmail, companyName]);
    useEffect(() => {
        if (userEmail || companyName) {
            fetchCounts(userEmail, companyName);
        }
    }, [userEmail, companyName, fetchCounts]);
    return (
        <Col md={12} style={{ paddingLeft: '15px', paddingRight: '15px' }}>
            <Row>
                {DATA.map((item, index) => (
                    <Col lg={3} sm={6} key={index}>
                        <Card
                            className="card card-icon-bg card-icon-bg-primary o-hidden mb-4"
                            style={{ height: '100px', paddingLeft: '10px' }}
                        >
                            <Card.Body>
                                {/* <FontAwesomeIcon
                                    icon={item.icon}
                                    className="me-2 text-primary mb-0 text-24 fw-semibold"
                                /> */}
                                <div className="content gap-1">
                                    {item.link ? (
                                        <Link
                                            to={item.link}
                                            state={item.state ? { ...item.state, userName, userEmail } : { userName, userEmail }}
                                            className="nav-link"
                                        >
                                            <p className="text-muted mb-0 text-capitalize title-responsive" style={{width:'150px'}}>
                                                {item.subtitle}
                                            </p>
                                            <p className="lead text-primary text-24 mb-0 text-capitalize" >
                                                {item.title}
                                            </p>
                                        </Link>
                                    ) : (
                                        <>
                                            <p className="text-muted mb-0 text-capitalize subtitle-responsive">
                                                {item.subtitle}
                                            </p>
                                            <p className="lead text-primary text-24 mb-0 text-capitalize">
                                                {item.title}
                                            </p>
                                        </>
                                    )}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Col>
    )
}

export default CompanyStatusCards
